import { render } from "./GorusmeFormView.vue?vue&type=template&id=91d22476"
import script from "./GorusmeFormView.vue?vue&type=script&lang=js"
export * from "./GorusmeFormView.vue?vue&type=script&lang=js"

import "./GorusmeFormView.vue?vue&type=style&index=0&id=91d22476&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__